import { pb } from '../../../shared/api/pocketbase';
import type { FetchOptionsResult } from '../../../shared/ui/Select';
import type { Provider } from './types';

export const fetchProviderOptions = async ({ page, search }: { page: number; search: string }): Promise<FetchOptionsResult> => {
  const perPage = 20;
  const safeSearch = search.replace(/"/g, '');
  const result = await pb.collection('provides').getList<Provider>(page, perPage, {
    sort: 'name',
    filter: safeSearch ? `name ~ "${safeSearch}"` : '',
    fields: 'id,name',
    requestKey: null,
  });
  return {
    items: result.items.map(p => ({ value: p.id, label: p.name })),
    hasMore: page * perPage < result.totalItems,
  };
};
